module.exports = __webpack_public_path__ + "563da4d9ed273b224a89019c22cf17a2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/chest-open.png
// module id = lsMg
// module chunks = 0